import localforage from 'localforage';
import { matchSorter } from 'match-sorter';
import sortBy from 'sort-by';

const bookmarkApi = (() => {
  function set(threads) {
    return localforage.setItem('savedThreads', threads);
  }

  async function getThreads(query) {
    let threads = await localforage.getItem('savedThreads');
    if (!threads) threads = [];
    if (query) {
      threads = matchSorter(threads, query, { keys: ['createdAt', 'title'] });
    }
    return threads.sort(sortBy('title', 'createdAt'));
  }

  async function saveThread(thread) {
    const savedThreads = await getThreads();
    savedThreads.unshift(thread);
    await set(savedThreads);
    return thread;
  }

  async function deleteThread(id) {
    const threads = await localforage.getItem('savedThreads');
    const index = threads.findIndex((thread) => thread.id === id);
    if (index > -1) {
      threads.splice(index, 1);
      await set(threads);
      return true;
    }
    return false;
  }

  return {
    getThreads,
    saveThread,
    deleteThread,
  };
})();

export default bookmarkApi;
